'use strict';


module.exports = {
    accordion: function () {
        if ($('.dynamic-accrdion-component').length > 0) {
            $('body').on('click', '.dynamic-accrdion-component .accrdion-heading', function () {
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).closest('.card').find('.accordion-description').slideUp('slow');
                } else {
                    $(this).closest('#accordion').find('.accrdion-heading').removeClass('active');
                    $(this).closest('#accordion').find('.accordion-description').slideUp('slow');
                    $(this).addClass('active');
                    $(this).closest('.card').find('.accordion-description').slideDown('slow');
                }
            });
        }
    },

    liveChatOpen: function () {
        $('body').on('click', '.live-chat-link', function () {
            $('.helpButtonEnabled').trigger('click');
        });
    }
};
